/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Newsletter_TitleInputs */



/**
* | output |
* | --- |
* | "Get the AWP Marine newsletter" |
*
* @param {Footer_Newsletter_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const footer_newsletter_title = /** @type {((inputs?: Footer_Newsletter_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Newsletter_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("订阅 AWP Marine 通讯")
	return /** @type {LocalizedString} */ ("Get the AWP Marine newsletter")
});